var path = 'C:/Projects/repos/NAERS-Web/src/components/app/dashboard/message/message.html';
var html = "<md-card flex> <md-toolbar class=\"md-table-toolbar md-default\"> <div class=md-toolbar-tools> <span class=md-truncate>{{$ctrl.title}}</span> <span flex></span> <div ng-transclude=actionButtons></div> </div> </md-toolbar> <div layout-padding> <p flex class=md-body-1>{{$ctrl.content || 'There is currently no message configured.'}}</p> </div> </md-card>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/dashboard/message/message.html
// module id = 626
// module chunks = 0